'use client'

import { Builder } from '@builder.io/react'

import { clickActionInputs } from '@src/hooks/useClickAction/useClickAction.builder'

import { Text, textStyleMap } from './Text'

Builder.registerComponent(Text, {
  name: 'Text',
  static: true,
  override: true,
  inputs: [
    {
      name: 'timePeriod',
      type: 'string',
      showIf: (properties) => properties.get('getValueFromCountdown'),
      enum: ['minutes', 'seconds', 'hours', 'days'],
    },
    {
      name: 'animated',
      type: 'boolean',
      showIf: (properties) => properties.get('getValueFromCountdown'),
    },
    {
      name: 'animatedBackground',
      type: 'color',
      showIf: (properties) => properties.get('animated'),
    },
    {
      name: 'text',
      type: 'html',
      required: true,
      autoFocus: true,
      bubble: true,
      showIf: (properties) => !properties.get('getValueFromCountdown'),
      defaultValue: 'Enter some text...',
    },
    {
      name: 'getValueFromCountdown',
      type: 'boolean',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      showIf: (_properties: any, _parent: any, parentElements: any[]) =>
        !!parentElements.find((element: any) => element?.component?.name === 'CountdownWrapper'),
      defaultValue: false,
      onChange: (options: any) => {
        if (options.get('getValueFromCountdown')) {
          options.set('text', ' ')
        } else {
          options.set('text', 'Enter some text...')
        }
      },
    },
    {
      name: 'style',
      type: 'string',
      defaultValue: 'Body MD',
      enum: Array.from(Object.keys(textStyleMap)),
    },
    ...clickActionInputs,
  ],
  defaultStyles: {
    height: 'auto',
    textAlign: 'center',
  },
})
